import React, {useState, useEffect} from "react";
import {
  Breadcrumb,
  Divider,
  Button,
  Card,
  Collapse,
  Form,
  Input,
  Row,
  Col,
  Space,
  Popconfirm,
  Badge,
  Select,
} from "antd";
import * as Icon from "react-feather";
import { useDispatch } from 'react-redux';
import appLoaderAction from '../../redux/action/app-loader-action';
import notifyUtitls from '../../utils/notify-utils';
import CustomTable from '../../components/table/custom-table';
import AddEditNotificationDialog from "./AddEditNotificationDialog";
import fileUtils from "../../utils/file-utils";
import { groupType } from "../../constants/app-constants";
import notificationService from "../../services/notification-service"; 
import EditableTagGroup from "../../components/input/editable-tag-group";
import DateTimeUtils from "../../utils/datetime-utils";
import userService from "../../services/user-service";

const { Panel } = Collapse;
const { Option } = Select;


function callback(key) {
  console.log(key);
}

const Notification = () => {
  const dispatch = useDispatch();
  const [isShowAddFileDialog, setIsShowAddFileDialog] = useState(false);
  const [editData, setEditData] = useState(null);
  const [condition, setCondition] = useState({title: null, status: null});
  const [dataList, setDataList] = useState([]);
  const [pagination, setPagination] = useState({currentPage: 1,rowPerPage: 10,rowCount: 0 });
  const [keywordList, setKeywordList] = useState([]);
  const [userList, setUserList] = useState([]);


  const columns = [
    {
      title: "ชื่อการแจ้งเตือน",
      dataIndex: "title",
      key: "name",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "รูปภาพ",
      key: "image",
      render: ({ notificationId, attachImage }) => {
        return (
          attachImage && attachImage?.originalFilename ? 
            (<img  className="w-100"
              src={fileUtils.getFileRenderUrl( groupType.NOTIFICATION, notificationId, attachImage.originalFilename)}>
            </img>) : null
        );
      },
    },
    {
      title: "คีย์เวิร์ด",
      key: "keywordList",
      render: ({ keywordList }) => {
      // console.log(' keywordList ', keywordList);
        return keywordList?.map((item, index) => {
          return (
            <span key={index}>
              {item} {index < keywordList.length - 1 ? ', ' : ''}{' '}
            </span>
          );
        });
      },
    },
    {
      title: "วันที่แจ้งเตือน",
      key: "activedate",
      className:"text-nowrap",
      render: ({ startDate, endDate }) => {
        // console.log('activedate ', startDate , endDate);
        return (
          <span>{`${DateTimeUtils.parseDateToString( startDate )} - ${DateTimeUtils.parseDateToString(endDate)}`}</span>
        );
      },
    },
    {
      title: 'จำนวนผู้เข้าชม',
      dataIndex: 'totalView',
      key: 'totalView',
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <Badge color={text ? '#4A9A0F' : '#CBCACA'} className="text-nowrap" text={text ? 'Online' : 'Offline'} />
      ),
    },
    {
      title: "ผู้บันทึก",
      key: "createBy",
      dataIndex: "createBy",
      render: (createBy) => {
        let check = userList.find((user) => createBy === user.userId);
        if (check) {
          return (`${check.profile?.firstName} ${check.profile?.lastName}`)
        }else{
          return (`undefined`)
        }
      },
    },
    {
      title: "ผู้แก้ไข",
      dataIndex: "updateBy",
      key: "updateBy",
      render: (updateBy) => {
        let check = userList.find((user) => updateBy === user.userId);
        if (check) {
          return (`${check.profile?.firstName} ${check.profile?.lastName}`)
        }else{
          return (`undefined`)
        }
      },
    },
  
    {
      title: 'ดำเนินการ',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (record) => (
        <Space size="middle">
            <a onClick={() => onClickEdit(record)} className="pe-3 border-end">
                <Icon.Edit size={18} />
            </a>
                          
            <Popconfirm
                title="ยืนยันการลบข้อมูล ?"
                onConfirm={() => onConfirmDelete(record.notificationId)}
                okText="ยืนยัน"
                cancelText="ยกเลิก" >
                <a >
                    <Icon.Trash size={18} />
                </a>
            </Popconfirm>
        </Space>
    ),
    },
  ];

  useEffect(() => {
    async function initData() {
      const response = await userService.search();
      setUserList(response.list);
    }
    initData();
    doSearch(1);
  }, []);

  useEffect(() => {
    if(editData){
      onEdit(editData);
    }
  }, [editData]);

  const onAdd = () => {
    setEditData(null);
		setIsShowAddFileDialog(true);
	};

  const onCancel= () => {
		setIsShowAddFileDialog(false);
		setEditData(null);
	};

  const onSaveComplete = () => {
    setEditData(null);
    setIsShowAddFileDialog(false);
    doSearch(1);
	};

  const onEdit = (data) =>{
    setEditData(data);
    setIsShowAddFileDialog(true);
  }

  const onChangeCondition = (event) => {
    const { name, value } = event.target;
    setCondition({ ...condition, [name]: value });
  }

  const onChangePage = (currentPage) =>{
    doSearch(currentPage);
  }

  const doSearch = async (currentPage) => {
    try {
        const newPaginate = {
            ...pagination,
            currentPage: currentPage ? currentPage : pagination.currentPage,
        };

        dispatch(appLoaderAction.enable());

        const newCondition = {title : condition.title, keywordList: keywordList, status: condition.status, createBy: condition.createBy}
        const result = await notificationService.search(newCondition, newPaginate);
        
        setDataList(result.list);
        setPagination(result.pagination ? result.pagination : newPaginate);

        dispatch(appLoaderAction.disale());
    } catch (err) {
        dispatch(appLoaderAction.disale());
        dispatch(notifyUtitls.error(err));
    }
  };

  const onClearSearch = () =>{
    setCondition({title: null, status: null});
    setKeywordList([]);
  }

  const onClickEdit = (record) => {
    try {
        dispatch(appLoaderAction.enable());
        setEditData(record);
        dispatch(appLoaderAction.disale());
    } catch (err) {
        dispatch(appLoaderAction.disale());
        notifyUtitls.error(err);
    }
  }

  const onConfirmDelete = (id)  => {
    onDelete(id);
  }

  const onDelete = async (id) => {
    try {
        dispatch(appLoaderAction.enable());
        await notificationService.remove({deleteIds: [id]});
        dispatch(appLoaderAction.disale());
        notifyUtitls.success('สำเร็จ', 'ลบข้อมูลสำเร็จ');
        doSearch(1);
    } catch (err) {
        dispatch(appLoaderAction.disale());
        notifyUtitls.error(err);
    }
  };

  const renderOptionUser = () => {
    return userList?.map((item) => {
      if (item?.profile) {
        const profile = item.profile;
        return (
          <Select.Option value={item.userId} key={item.userId}>
            {`${profile.firstName} ${profile.lastName}`}
          </Select.Option>
        );
      } else {
        return null
      }
    });
  };

  const onChangeSelect = (name) => {
    return (value) => {
      setCondition({ ...condition, [name]: value });
    };
  }

  return (
    <div>
      <h2 className="color-primary-title">การแจ้งเตือน</h2>
      <Breadcrumb>
        <Breadcrumb.Item>การจัดการเนื้อหา</Breadcrumb.Item>
        <Breadcrumb.Item>การแจ้งเตือน</Breadcrumb.Item>
      </Breadcrumb>
      <Divider className="mt-2 mb-4" />
      <div className="d-flex justify-content-between">
        <Button type="primary" className="mx-2" htmlType="button" onClick={() => onAdd()}>
            <Icon.Plus className="me-1" size={18} /> เพิ่มการแจ้งเตือน
        </Button>
      </div>
      <Card className="mt-4" bordered={false}>
        <Collapse className="mb-4" defaultActiveKey={["1"]} onChange={callback}>
          <Panel header="ตัวกรอง" key="1">
            <div>
              <Form layout="vertical">
                <Row gutter={20}>
                  <Col span={7}>
                    <Form.Item label="ชื่อการแจ้งเตือน" className="mb-0">
                      <Input
                          name="title"
                          value={condition.title}
                          onChange={onChangeCondition}
                      />
                    </Form.Item>
                  </Col>
                  {/* <Col span={5}>
                    <Form.Item label="ผู้บันทึก" className="mb-0">
                      <Input
                          name="updateName"
                          value={condition.updateName}
                          onChange={onChangeCondition}
                      />
                    </Form.Item>
                  </Col> */}

                  <Col span={5}>
                    <Form.Item label="คีย์เวิร์ด" className="mb-0">
                      <EditableTagGroup customWidth="100%" 
                        name="keywordList" 
                        onChange={setKeywordList} 
                        tags={keywordList} />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="ผู้บันทึก" className="mb-0">
                      <Select
                        showSearch
                        placeholder="Search to Select"
                        optionFilterProp="children"
                        allowClear
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                        value={condition.createBy}
                        onChange={onChangeSelect('createBy')}
                      >
                        {renderOptionUser()}

                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="สถานะ" className="mb-0">
                      <Select name="status" value={condition.status} onChange={onChangeSelect('status')}>
                        <Option value={null}>All</Option>
                        <Option value={true}>Online</Option>
                        <Option value={false}>Offline</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="mt-4">
                    <Button type="primary" className="w-100" onClick={() => doSearch(1)}>
                      <Icon.Search className="me-1" size={18} /> ค้นหา
                    </Button>
                  </Col>
                  <Col className="mt-4">
                    <Button className="btn-gray" onClick={() => onClearSearch()}>ล้างค่า</Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Panel>
        </Collapse>
        <CustomTable
            rowKey="notificationId"
            tableName="notificationTable"
            columns={columns}
            data={dataList}
            scroll={{ x: true }}
            isPagination={true}
            onChangePage={onChangePage}
            currentPage={pagination.currentPage}
            pageSize={pagination.rowPerPage}
            totalRecord={pagination.rowCount}
        />
      </Card>

      <AddEditNotificationDialog 
          isShow={isShowAddFileDialog}
          editData={editData}
          onCancel={onCancel}
          onSaveComplete={onSaveComplete}></AddEditNotificationDialog>
    </div>
  );
};

export default Notification;
